import { Col, Row, SelectProps } from 'antd';
import 'chart.js/auto';

import DoughnutBox from './DoughnutBox';
import DoughnutBoxTitle from './DoughnutBoxTitle';
import DoughnutBoxTitleWithComparator from './DoughnutBoxTitleWithComparator';
import Title from './Title';

interface TestMatchProps {
  archetypeName?: string;
  archetypeMatch?: number;
  rawPotential?: number;
  selectValue?: SelectProps['value'];
  comparatorOptions?: SelectProps['options'];
  onChangeFunction?: SelectProps['onChange'];
  compareGrade?: number;
}

const TestMatch: React.FC<TestMatchProps> = ({
  archetypeMatch = 0,
  archetypeName,
  rawPotential,
  selectValue,
  comparatorOptions,
  onChangeFunction,
  compareGrade,
}) => {
  const archetypeTooltip: {
    [key: string]: string;
  } = {
    Vendas:
      'Posições cujos desafios são influenciar pessoas, apresentar soluções e acompanhar resultados. Ex: Inbound/Outbound Sales, Field Sales, SDR, Closer.',
    Atendimento:
      'Posições cujos desafios são atender e resolver problemas de clientes e/ou parceiros.​ Ex: Consultor de atendimento e C.S., gestores de call center ou SAC​',
    Analítico:
      'Posições cujos desafios são analisar informações, tirar conclusões e fazer melhorias.​ Ex: T.I., análise de dados no geral, funções de back office, RH, Marketing​',
    Generalista:
      'Posições cujos desafios exigem versatilidade e flexibilidade para tomada de decisão, além de habilidades de liderança.​ ​Ex: Cargos estratégicos e de liderança, Business Partners, recrutadores programas de estágio e trainee.',
  };

  return (
    <Col>
      <Title title="Match" />
      <Row gutter={[16, 16]}>
        {archetypeName && (
          <Col span={8}>
            <DoughnutBox
              grade={archetypeMatch}
              title={
                <DoughnutBoxTitle
                  archetypeName={archetypeName}
                  tooltipText={archetypeTooltip[archetypeName] || ''}
                />
              }
            />
          </Col>
        )}
        <Col span={8}>
          <DoughnutBox
            grade={compareGrade || 0}
            title={
              <DoughnutBoxTitleWithComparator
                title="Selecione um arquétipo"
                value={selectValue}
                onChange={onChangeFunction}
                options={comparatorOptions}
              />
            }
          />
        </Col>
        <Col span={8}>
          <DoughnutBox
            grade={rawPotential}
            title={
              <DoughnutBoxTitle
                archetypeName="Potencial Bruto"
                tooltipText="O potencial bruto é uma média ponderada dos testes de habilidade: Raciocínio Fluido, Social e Motivacional. Essa nota representa o potencial absoluto da pessoa, ou seja, uma nota do potencial da pessoa independente da posição. Geralmente é interessante para posições que exigem versatilidade e que objetiva-se crescimento rápido."
              />
            }
          />
        </Col>
      </Row>
    </Col>
  );
};

export default TestMatch;
